import { ReactElement } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { useMunicipalPropertySections } from "@/domain/municipal-property/hooks/use-municipal-property-sections";

export function MunicipalPropertyWorkspaceRedirect(): ReactElement {
  const { workspaceUrl } = useParams();
  return <Navigate to={`/${workspaceUrl}`} replace />;
}

export function MunicipalPropertyIndexPage(): ReactElement | null {
  const { isLoading, defaultSectionPath } = useMunicipalPropertySections();
  const { search, hash } = useLocation();
  if (isLoading) return null;
  if (!defaultSectionPath) return <MunicipalPropertyWorkspaceRedirect />;
  return <Navigate to={{ pathname: defaultSectionPath, search, hash }} replace />;
}
